const nameReducer = (
  state = {
    type: "",
    loanType: "",
    purchasePrice: "",
    downPaymentInUSDs: "",
    downPaymentInPercents: "",
    CreditScore: "",
    ficoScore: "",
    ShowButtons: true,
    propertyType: "",
    propertyUse: "",
    penaltyTerm: "",
    immigrationStatus: "",
    documentType: "",
    lowRates: undefined,
    lowRatesOption: undefined,
    estimatedValue: "",
    loanBalance: "",
    loanAmount: "",
    estimatedHomeValue: "",
    cashoutAmount: "",
    zipCode: "",
    countryState: "Select a State",
    stateCounty: "",
    stateCountyName: "",
    veteran: "",
    stateList: "",
    investmentPurposeBusiness: null,
    amortizationType: "",
    amortizationTerm: "",
    priceScenarioResponse: {
      priceScenarioColumnsdata: [],
      productTitleDetailsFromResponse: [],
    },
    textDescription: {},
    unhideCutomizeLabel: false,
    fhaTypeQuestion: '',
    productTypeQuestion: '',
    priceDataLengthValue: false,
    ficoType: false,
    miCoverageType: '',
    subordinateFinance: 0,
    highPriceLimit: {},
    isLoadingPriceScenario: false,
    errInBrokerForm: false,
    storeConfigData: null,
    deviceType: window.innerWidth < 575 ? 'mobile' : 'desktop',
    screenWidthXHeight: [window.innerWidth, window.innerHeight],
    isDtiRatioHigher: null,
    interestOnlyPayment: null,
    escrow: null,
    armValue: '',
    previousAmorType: '',
    seeMyLoanFormData: {},
    dpaProduct: '',
    dpaProductQstnAllowed: true,
    backRatioInPercent: '',
    showQuoteTable1: false,
    showQuoteTable2: true,
  },
  action
) => {
  switch (action.type) {
    case "TYPESELECTED":
      return { ...state, type: action.payload };
    case "LOANTYPESELECTED":
      return { ...state, loanType: action.payload };
    case "PURCHASEPRICEUPDATE":
      return { ...state, purchasePrice: action.payload };
    case "DOWNPAYMENTINUSDSUPDATE":
      return { ...state, downPaymentInUSDs: action.payload };
    case "DOWNPAYMENTINPERCENTSSUPDATE":
      return { ...state, downPaymentInPercents: action.payload };
    case "CREDITSCOREUPDATE":
      return { ...state, CreditScore: action.payload };
    case "FICOSCOREUPDATE":
      return { ...state, ficoScore: action.payload };
    case "SHOWBUTTONSUPDATE":
      return { ...state, ShowButtons: action.payload };
    case "PROPERTYTYPEUPDATE":
      return { ...state, propertyType: action.payload };
    case "PROPERTYUSEDUPDATE":
      return { ...state, propertyUse: action.payload };
    case "PENALTYTERMUPDATE":
      return { ...state, penaltyTerm: action.payload };
    case "IMMIGRATIONSTATUSUPDATE":
      return { ...state, immigrationStatus: action.payload }
    case "DOCUMENTTYPEUPDATE":
      return { ...state, documentType: action.payload }
        
    case "LOWRATESUPDATE":
      return { ...state, lowRates: action.payload };
    case "LOWRATESOPTION":
      return { ...state, lowRatesOption: action.payload };
    case "ESTIMATEDVALUEUPDATED":
      return { ...state, estimatedValue: action.payload };
    case "LOANBALANCEUPDATED":
      return { ...state, loanBalance: action.payload };
    case "CASHOUTAMOUNTUPDATED":
      return { ...state, cashoutAmount: action.payload };
    case "ESTIMATEDHOMEVALUEUPDATED":
      return { ...state, estimatedHomeValue: action.payload };
    case "LOANAMOUNTTOTALUPDATE":
      return { ...state, loanAmount: action.payload };
    case "ZIPCODEUPDATE":
      return { ...state, zipCode: action.payload };
    case "COUNTRYSTATEUPDATE":
      return { ...state, countryState: action.payload };
    case "STATECOUNTYUPDATE":
      return { ...state, stateCounty: action.payload };
    case "STATECOUNTYNAMEUPDATE":
      return { ...state, stateCountyName: action.payload };
    case "VETERANUPDATE":
      return { ...state, veteran: action.payload };
    case "STATELISTUPDATE":
      return { ...state, stateList: action.payload };
    case "SELECTEDPROPERTYPURPOSE":
  
      return { ...state, investmentPurposeBusiness: action.payload };
    case "AMORTIZATIONUPDATE":
      return { ...state, amortizationTerm: action.payload };
    case "AMORTIZATIONTYPEUPDATE":
      return { ...state, amortizationType: action.payload };
    case "PREVIOUSAMORTIZATIONTYPEUPDATE":
      return { ...state, previousAmorType: action.payload };
    case "armValueUpdate":
      return { ...state, armValue: action.payload };
    case "PRICESCENARIOUPDATE":
      return { ...state, priceScenarioResponse: action.payload };
    case "TEXTDESCRIPTIONUPDATE":
      return { ...state, textDescription: action.payload };
    case "UNHIDECUSTIMEQUOTELABEL":
      return { ...state, unhideCutomizeLabel: action.payload };
    case "FHATYPEQUESTIONUPDATE":
      return { ...state, fhaTypeQuestion: action.payload };
    case "PRODUCTTYPEQUESTIONUPDATE":
      return { ...state, productTypeQuestion: action.payload };
    case "RESPONSELENGTHUPDATE":
        return { ...state, priceDataLengthValue: action.payload };
    case "FICOTYPEUPDATE":
        return { ...state, ficoType: action.payload };
    case "MICOVERAGETYPEUPDATE":
        return { ...state, miCoverageType: action.payload };
    case "SUBORDINATEFINANCEUPDATE":
        return { ...state, subordinateFinance: action.payload };
    case "CHECKLIMITPRICE":
      return { ...state, highPriceLimit: action.payload };    
    case "SETLOADINGPRICESCENARIO":
      return { ...state, isLoadingPriceScenario: action.payload };    
    case "SETERRORINBROKERFORM":
      return { ...state, errInBrokerForm: action.payload };    
    case "SETSTORECONFIGDATA":
      return { ...state, storeConfigData: action.payload };    
    case "SETDEVICETYPE":
      return { ...state, 
        deviceType: action.payload.deviceType,
        screenWidthXHeight: action.payload.screenWidthXHeight // array
      }; 
    case "ISDTIRATIOHIGHERUPDATE":
      return { ...state, isDtiRatioHigher: action.payload };
    case "INTERESTONLYPAYMENTUPDATE":
      return { ...state, interestOnlyPayment: action.payload };
    case "ESCROWUPDATE":
      return { ...state, escrow: action.payload };
    case "SETSEEMYLOANFORMDATA":
      return { ...state, seeMyLoanFormData: action.payload };
    case "DPAUPDATE":
      return { ...state, dpaProduct: action.payload };
    case "BACKRATIOINPERCENTSSUPDATE":
        return { ...state, backRatioInPercent: action.payload };
    case "SETCUSTOMVALUE":
        return { ...state, [action.payload.stateName]: action.payload.value };
    default:
      return state;
  }
};
export default nameReducer;
